const autoNgTemplateLoaderTemplate1 = require('./recommended-steps.template.html');

'use strict';

import { SOLUTION_TYPE } from '../../modules/shared/constants/user-info/solutionType';

(function () {
    angular
        .module('app.recommendedSteps', [])
        .config(recommendedStepsConfig);

    recommendedStepsConfig.$inject = ['$routeProvider'];

    function recommendedStepsConfig($routeProvider) {
        $routeProvider
            .when('/recommended-steps/:id', {
                disableCache: true,
                templateUrl: autoNgTemplateLoaderTemplate1,
                controller: 'RecommendedStepsController',
                controllerAs: 'vm',
                resolve: {
                    loginRequired: ['AuthService', function (AuthService) {
                        return AuthService.loginRequired();
                    }]
                },
                pageConfig: {
                    solution: SOLUTION_TYPE.NUTRITION,
                }
            })
    }
})();
